import React, { useContext, useEffect, useRef } from 'react'
import Header from './Components/Header'
import { ParagraphComp } from '../../Components/ParagraphComp/ParagraphComp';
import ButtonComp from '../../Components/ButtonComp/ButtonComp';
import { useState } from 'react';
import SearchBox from './Components/SearchBox';
import HeaderCompo from '../../Components/HeaderComp/HeaderCompo';
// import { Pagination } from '@mui/material';
import ErrorMessage from './Components/ErrorMessage';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getCause, getCount, getDistricts, getIp, getPopulations, getSearchResults, getStates, postUserCountApi, SearchPostCall } from '../../Store/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import { ImageComp } from '../../Components/ImageCompo/ImageComp';
import InitialMessage from './Components/InitialMessage';
import GeographyAdv from './Components/GeographyAdv';
import Cause from './Components/CauseAdv';
import MakeADifference from './Components/MakeADifferenceAdv';
import Finance from './Components/FinanceAdv';
import PlaceIcon from '@mui/icons-material/Place';
import { enqueueSnackbar } from 'notistack';
import CustomSelection from '../../Components/SelectionComp/CustomSelection';
import { Pagination, Stack } from '@mui/material';
import HeaderSec from '../../Components/HeaderSec/HeaderSec';
import FooterComp from '../../Components/FooterComp/FooterComp';
import TrustAndTransparencyAdv from './Components/TrustAndTransparencyAdv';
import { useSearchContext } from './Context';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { publicIpv4 } from "public-ip";
import { getSummaryDescription } from '../../Functions/formatters';

const NpoSearch = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const advancedSearchMiniTab = searchParams.get('advancedSearchMiniTab');
  const miniTab = JSON.parse(decodeURIComponent(advancedSearchMiniTab))
  const navigate = useNavigate()
  const [tabs, setTabs] = useState(miniTab)
  const [TempSearch, setTempSearch] = useState();
  const buttons = ['Geography', 'Cause', 'Financial', 'Get Involved', 'Trust and Transparency Level']
  const [selectedFields, setSelectedFields] = useState({ 'Geography': true });
  const [AdvPostData, setAdvPostData] = useState()
  const [selectedFilter, setSelectedFilter] = useState()
  const location = useLocation();
  const { state } = location;
  const { searchKey, setSearchKey } = useSearchContext();
  const { searchedData, setSearchedData } = useSearchContext();
  const [currentPage, setCurrentPage] = useState(1);
  const formRef = useRef(null);
  const clearButtonRef = useRef(null);
  const [ip, setIp] = useState("");
  // const [count, setCount] = useState();
  const queryClient = useQueryClient()


  useEffect(() => {
    if (state && state?.searchValue) {
      setSearchKey(state?.searchValue);
    }
  }, [state]);
  const selectedSeal = location?.state?.setFilter
  // all fields validations are checking here
  const modelSchema = Yup.object({
    cause_thematic_area: Yup.string(),
    populations_segments_served: Yup.string(),
    tax_12a: Yup.boolean(),
    tax_10c: Yup.boolean(),
    tax_80g: Yup.boolean(),
    csr_registration: Yup.string(),
    sse_listing: Yup.string(),
    fcra: Yup.string(),
    slabs_exp_upto_10lakh: Yup.boolean(),
    slabs_exp_upto_50lakh: Yup.boolean(),
    slabs_exp_upto_1cr: Yup.boolean(),
    slabs_exp_upto_5cr: Yup.boolean(),
    slabs_exp_upto_10cr: Yup.boolean(),
    slabs_exp_upto_20cr: Yup.boolean(),
    slabs_exp_upto_50cr: Yup.boolean(),
    slabs_exp_above_50cr: Yup.boolean(),
    slabs_asst_upto_50lakh: Yup.boolean(),
    slabs_asst_upto_1cr: Yup.boolean(),
    slabs_asst_upto_10cr: Yup.boolean(),
    slabs_asst_upto_20cr: Yup.boolean(),
    slabs_asst_upto_50cr: Yup.boolean(),
    slabs_asst_upto_100cr: Yup.boolean(),
    slabs_asst_above_100cr: Yup.boolean(),
    insti_domestic: Yup.boolean(),
    public_retail_domestic: Yup.boolean(),
    public_hni_domestic: Yup.boolean(),
    corp_domestic: Yup.boolean(),
    gov_domestic: Yup.boolean(),
    insti_foreign: Yup.boolean(),
    public_retail_foreign: Yup.boolean(),
    public_hni_foreign: Yup.boolean(),
    corporate_foreign: Yup.boolean(),
    gov_foreign: Yup.boolean(),
    un: Yup.boolean(),
    pan_india: Yup.string(),
    state: Yup.string(),
    district: Yup.array(),
    city: Yup.string(),
    pincode: Yup.string()
      .matches(/^\d{6}$/, 'Pincode must be exactly 6 digits'),
    give_money: Yup.boolean(),
    gift_in_kind: Yup.boolean(),
    volunteer: Yup.boolean(),
    purchase_products: Yup.boolean(),
    celebrate: Yup.boolean(),
    purchase_products: Yup.boolean(),
    platinum: Yup.boolean(),
    gold: Yup.boolean(),
    silver: Yup.boolean(),
    bronze: Yup.boolean(),
    'Bronze under review for higher certification': Yup.boolean(),
    'basic level': Yup.boolean(),
    'entry level': Yup.boolean(),
  });


  // local storage getting token
  const token = localStorage.getItem('NpoToken')
  const dataUserAccessToken = localStorage.getItem('dataUserAccessToken')

  // Update the main tab name for Advanced Search
  const updateBtnName = (btn) => {
    const existingMiniTab = searchParams.get('advancedSearchMiniTab');
    const miniTabQuery = existingMiniTab ? `&advancedSearchMiniTab=${encodeURIComponent(existingMiniTab)}` : '';
    const AdvancedSearchUrl = searchParams.get('AdvancedSearch');
    const AdvancedSearchUrlQuery = AdvancedSearchUrl ? `&AdvancedSearch=${encodeURIComponent(AdvancedSearchUrl)}` : '';

    navigate(`/search?advancedSearchTab=${encodeURIComponent(JSON.stringify(btn))}${miniTabQuery}${AdvancedSearchUrlQuery}`);
  };
  // fetching not hardcoded data

  const { isLoading: StateLoading, data: stateDatas } = useQuery({
    queryKey: ['StateResults'],
    queryFn: () => getStates(),
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    // staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });
  const { isLoading: districtsLoading, data: districtsDatas } = useQuery({
    queryKey: ['DistrictsResults'],
    queryFn: () => getDistricts(),
    refetchOnWindowFocus: false,
    cacheTime: 1000 * 60 * 5,
    // staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });
  const { isLoading: populationsLoading, data: populationsDatas } = useQuery({
    queryKey: ['populationsResults'],
    queryFn: () => getPopulations(),
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 5,
    // staleTime: 0, // Setting staleTime to 0 will make sure data is marked as stale immediately
  });
  const { isLoading: CauseLoading, data: CauseDatas } = useQuery({
    queryKey: ['CauseResults'],
    queryFn: () => getCause(searchKey),
    refetchOnWindowFocus: false,
  });

  // checking errors
  const handleCreateError = (error) => {
    console.error("Search error:", error);
    setSearchedData([]);

    let message = "No results found or an error occurred while searching. Please try again.";

    const resData = error?.response?.data;
    if (typeof resData === 'string' && resData.trim() && !resData.trim().startsWith('<')) {
      message = resData.trim();
    } else if (resData && typeof resData === 'object') {
      if (typeof resData.status_message === 'string' && resData.status_message.trim()) {
        message = resData.status_message.trim();
      } else if (typeof resData.message === 'string' && resData.message.trim()) {
        message = resData.message.trim();
      } else if (typeof resData._error_message === 'string' && resData._error_message.trim()) {
        message = resData._error_message.trim();
      } else if (resData._server_messages) {
        try {
          const parsed = JSON.parse(resData._server_messages);
          if (Array.isArray(parsed) && parsed.length > 0) {
            const first = typeof parsed[0] === 'string' ? JSON.parse(parsed[0]) : parsed[0];
            if (first?.message && typeof first.message === 'string') {
              message = first.message;
            }
          }
        } catch (e) {}
      } else if (typeof resData.exception === 'string' && resData.exception.trim()) {
        message = resData.exception.trim();
      }
    } else if (typeof error?.message === 'string' && error.message.trim()) {
      message = error.message.trim();
    }

    enqueueSnackbar(message, { variant: 'error' });
  };
  // checking success

  const handleCreateSuccess = () => {
    // enqueueSnackbar('Login success!', { variant: 'success' });
  };

  const createFarmerMutationOptions = {
    onSuccess: handleCreateSuccess,
    onError: handleCreateError,
  };
  //  top search api calling
  const {
    mutate: initialSearch,
    isPending: fieldLoading,
    data: searchResults,
    reset: resetSearch
  } = useMutation({
    mutationFn: getSearchResults,
    ...createFarmerMutationOptions,
  });
  //  top advanced search api calling

  const {
    mutate: AdvSearchCall,
    isPending: advLoading,
    data: getData,
    reset,
  } = useMutation({
    mutationFn: SearchPostCall,
    ...createFarmerMutationOptions,
  });

  const handleClearSearch = () => {
    setSearchedData([]);
    setSearchKey('');
    setTempSearch('');
    resetSearch();
    navigate(`/search`, { replace: true });
  };

  // slice getting advanced search and top search results

  useEffect(() => {
    if (Array.isArray(getData?.documents) && getData.documents.length > 0) {
      setSearchedData(getData.documents);
    } else if (Array.isArray(searchResults?.documents) && searchResults.documents.length > 0) {
      setSearchedData(searchResults.documents);
    } else {
      setSearchedData([]);
    }
  }, [getData, searchResults, token]);


  // getting url data

  const query = searchParams.get('query');
  const header = searchParams.get('header');
  const landing = searchParams.get('landing');
  const AdvancedSearchUrlQuery = searchParams.get('AdvancedSearch');
  const advancedSearchTab = searchParams.get('advancedSearchTab');

  useEffect(() => {
    const newSearchKey = query || header || landing; // Determine the current search term

    if (newSearchKey) {
      if (newSearchKey !== searchKey) {
        setCurrentPage(1); // Reset to page 1 when search key changes
        setSearchKey(newSearchKey);
        return; // Prevent unnecessary API calls before state updates
      }
      initialSearch({ searchKey: newSearchKey, currentPage });
    } else if (!AdvancedSearchUrlQuery && !advancedSearchTab && !advancedSearchMiniTab) {
      handleClearSearch();
    }
  }, [query, header, landing, currentPage, searchKey]);

  // Added `currentPage` here


  // landing page default filters

  useEffect(() => {
    if (location?.state?.filterButton) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      switch (location?.state?.filterButton) {
        case 'trustAndTransparency':
          setSelectedFields({ ['Trust and Transparency Level']: true })
          break;
        case 'cause':
          setSelectedFields({ ['Cause']: true })
          break;
        case 'geography':
          setSelectedFields({ ['Geography']: true })
          break;
        case 'financials':
          setSelectedFields({ ['Financial']: true })
          break;
        case 'wayToMakeADifference':
          setSelectedFields({ ['Get Involved']: true })
          break;
        default:
          break;
      }
    }
  }, [location?.state?.filterButton])



  const appearSeals = [
    'platinum',
    'silver',
    'bronze',
    'bronze under review for higher certification'
  ];
  const certificationOrder = [
    'platinum',
    'gold',
    'silver',
    'bronze',
    'bronze under review for higher certification',
    'basic level',
    'entry level',
    'claim your profile'
  ];

  // filtering the Organisation Name (A-Z) and Trust & Transparency Level (High to Low)
  useEffect(() => {
    // if (selectedFilter && searchedData.length > 0) {
    //   let FilteredData = [...searchedData];

    //   console.log("Selected Filter:", selectedFilter);

    //   // Sorting by Organisation Name (A-Z)
    //   if (selectedFilter === "Organisation Name (A-Z)") {
    //     FilteredData.sort((a, b) => a.organisation_name.localeCompare(b.organisation_name));
    //   }

    //   // Sorting by Trust & Transparency Level (High to Low)
    //   else if (selectedFilter === "Trust & Transparency Level (High to Low)") {
    //     console.log("Applying Trust & Transparency Filter...");

    //     if (!certificationOrder || !Array.isArray(certificationOrder)) {
    //       console.error("certificationOrder is undefined or not an array:", certificationOrder);
    //       return;
    //     }

    //     FilteredData.sort((a, b) => {
    //       const levelA = a.certification_level?.toLowerCase() || "";
    //       const levelB = b.certification_level?.toLowerCase() || "";

    //       const indexA = certificationOrder.indexOf(levelA);
    //       const indexB = certificationOrder.indexOf(levelB);

    //       console.log("Sorting Levels: ", { levelA, indexA, levelB, indexB });

    //       return indexA - indexB;
    //     });
    //   }

    //   // Ensure state updates only if the data has changed
    //   if (!FilteredData.every((item, index) => item === searchedData[index])) {
    //     console.log("Updating searchedData with filtered results...");
    //     setSearchedData([...FilteredData]); // Force re-render by creating a new array
    //   }
    // }
  }, [selectedFilter, searchedData, getData]); // ✅ Depend on searchedData to ensure re-sorting


  console.log("searchedData>>>>", searchedData)

  const totalPages = Math.ceil((getData?.total_count || searchResults?.total_count || 0) / 5);  // const paginatedData = searchedData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    window.scrollTo(0, 0); // Scroll to top
  };




  const advancedSearchUrlQuery = searchParams.get('AdvancedSearch');

  const selectedDifference = location?.state?.setDifferenceFilter


  const indicator = advancedSearchUrlQuery
    ? (() => {
      try {
        const decodedQuery = decodeURIComponent(advancedSearchUrlQuery);
        const parsedData = JSON.parse(decodedQuery);
        return parsedData?.indicator?.toLowerCase().split(',').map(s => s.trim()) || [];
      } catch (error) {
        return [];
      }
    })()
    : [];

  useEffect(() => {
    if ((selectedDifference && formRef.current || selectedSeal)) {
      formRef.current.submitForm();
    } else if (location?.state?.filterButton === 'trustAndTransparency') {
      formRef.current.submitForm();
    }
  }, [selectedDifference, location?.state?.filterButton]);
  const checkDefaultFilter = ['platinum', 'gold', 'silver', 'bronze', 'basic', 'entry']

  const initialValues = {
    cause_thematic_area: AdvPostData?.cause_thematic_area || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.cause_thematic_area || '',
    populations_segments_served: AdvPostData?.populations_segments_served || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.populations_segments_served || '',
    tax_12a: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.tax_12a ? true : false,
    tax_10c: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.tax_10c ? true : false,
    tax_80g: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.tax_80g ? true : false,
    tax_35a: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.tax_35a ? true : false,
    tax_35b: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.tax_35b ? true : false,
    csr_registration: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.csr_registration ? 'Yes' : false,
    sse_listing: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.sse_listing ? 'Yes' : false,
    fcra: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.fcra ? 'Yes' : false,
    slabs_exp_upto_10lakh: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_10lakh ? true : false,
    slabs_exp_upto_50lakh: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_50lakh ? true : false,
    slabs_exp_upto_1cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_1cr ? true : false,
    slabs_exp_upto_5cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_5cr ? true : false,
    slabs_exp_upto_10cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_10cr ? true : false,
    slabs_exp_upto_20cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_20cr ? true : false,
    slabs_exp_upto_50cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_upto_50cr ? true : false,
    slabs_exp_above_50cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_exp_above_50cr ? true : false,
    slabs_asst_upto_50lakh: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_50lakh ? true : false,
    slabs_asst_upto_1cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_1cr ? true : false,
    slabs_asst_upto_5cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_5cr ? true : false,
    slabs_asst_upto_10cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_10cr ? true : false,
    slabs_asst_upto_20cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_20cr ? true : false,
    slabs_asst_upto_50cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_50cr ? true : false,
    slabs_asst_upto_100cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_upto_100cr ? true : false,
    slabs_asst_above_100cr: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.slabs_asst_above_100cr ? true : false,
    insti_domestic: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.insti_domestic ? true : false,
    public_retail_domestic: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.public_retail_domestic ? true : false,
    public_hni_domestic: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.public_hni_domestic ? true : false,
    corp_domestic: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.corp_domestic ? true : false,
    gov_domestic: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.gov_domestic ? true : false,
    insti_foreign: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.insti_foreign ? true : false,
    public_retail_foreign: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.public_retail_foreign ? true : false,
    public_hni_foreign: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.public_hni_foreign ? true : false,
    corporate_foreign: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.corporate_foreign ? true : false,
    gov_foreign: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.gov_foreign ? true : false,
    un: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.un ? true : false,
    pan_india: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.pan_india || '',
    state: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.state || '',
    district: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.district?.length > 0 ? JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.district?.split(',') : [],
    city: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.city || '',
    pincode: JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.pincode || '',
    give_money: (selectedDifference && selectedDifference?.includes('Donate money')) || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.['give_money'] ? true : false,
    gift_in_kind: (selectedDifference && selectedDifference?.includes('Gift in-kind')) || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.['gift_in_kind'] ? true : false,
    volunteer: (selectedDifference && selectedDifference?.includes('Volunteer')) || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.['volunteer'] ? true : false,
    purchase_products: (selectedDifference && selectedDifference?.includes('Purchase products')) || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.['purchase_products'] ? true : false,
    celebrate: (selectedDifference && selectedDifference?.includes('Celebrate occasions')) || JSON.parse(decodeURIComponent(advancedSearchUrlQuery))?.['celebrate'] ? true : false,
    // platinum: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal?.toLowerCase() === 'platinum') || (indicator.includes('platinum')) ? true : false,
    // gold: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal?.toLowerCase() === 'gold') || indicator.includes('gold') ? true : false,
    // silver: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal?.toLowerCase() === 'silver') || indicator.includes('silver') ? true : false,
    // bronze: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal?.toLowerCase() === 'bronze') || indicator.includes('bronze'),
    // 'Bronze under review for higher certification': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal.toLowerCase() === 'bronze +') || indicator.includes('bronze under review for higher certification') ? true : false,
    // 'basic level': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal?.toLowerCase() === 'basic') || indicator.includes('basic level') ? true : false,
    // 'entry level': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.includes(selectedSeal?.toLowerCase())) || (selectedSeal && selectedSeal?.toLowerCase() === 'entry') || indicator.includes('entry level') ? true : false,
    platinum: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
          (selectedSeal && selectedSeal.some(s => s?.toLowerCase() === 'platinum')) || 
          (indicator.includes('platinum')),
          
    gold: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
          (selectedSeal && selectedSeal.some(s => s?.toLowerCase() === 'gold')) || 
          (indicator.includes('gold')),
          
    silver: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
            (selectedSeal && selectedSeal.some(s => s?.toLowerCase() === 'silver')) || 
            (indicator.includes('silver')),
            
    bronze: (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
            (selectedSeal?.some(s => s?.toLowerCase() === 'bronze')) || 
            (indicator.includes('bronze')),
            
    'Bronze under review for higher certification': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
                                                  (selectedSeal && selectedSeal.some(s => s.toLowerCase() === 'bronze +')) || 
                                                  (indicator.includes('bronze under review for higher certification')),
                                                  
    'basic level': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
                  (selectedSeal && selectedSeal.some(s => s?.toLowerCase() === 'basic')) || 
                  (indicator.includes('basic level')),
                  
    'entry level': (location?.state?.filterButton === 'trustAndTransparency' && !checkDefaultFilter.some(filter => selectedSeal?.map(s => s.toLowerCase()).includes(filter))) || 
                  (selectedSeal && selectedSeal.some(s => s?.toLowerCase() === 'entry')) || 
                  (indicator.includes('entry level'))
  };
  console.log("location>>>", location?.state?.filterButton)


  const submitData = (data) => {
    setCurrentPage(1)
    let ChangeData = { ...data };
    if (query || landing || header) {
      searchParams.delete("query");
      searchParams.delete("landing");
      searchParams.delete("header");
      resetSearch()
      // Update URL without refreshing
      window.history.replaceState(
        null,
        "",
        `${window.location.pathname}?${searchParams.toString()}`
      );
    }
    // Step 1: Remove all `false` and `''` values first
    Object.keys(ChangeData).forEach((key) => {
      if (ChangeData[key] === false || ChangeData[key] === '') {
        delete ChangeData[key];
      }
    });

    let indicatorValues = [];

    // Step 2: Process remaining keys
    Object.keys(ChangeData).forEach((ele) => {

      if (ele === 'csr_registration2') {
        ChangeData['csr_registration'] = ChangeData[ele] ? 'Yes' : 'No';
        delete ChangeData[ele]; // Remove after assigning
      }
      else if (certificationOrder.includes(ele.toLowerCase()) && ChangeData[ele]) {
        indicatorValues.push(ele);
        delete ChangeData[ele]; // Remove from ChangeData only if it belongs to certificationOrder
      }
      else if (ele === 'district' && ChangeData[ele]) {
        ChangeData['district'] = ChangeData['district'].join(', '); // Remove from ChangeData only if it belongs to certificationOrder
      }
      else if (ChangeData[ele]?.length === 0) {
        delete ChangeData[ele]; // Remove from ChangeData only if it belongs to certificationOrder
      }
      else if (ChangeData[ele] === true) {
        ChangeData[ele] = 'Yes'; // Convert true to "Yes"
      }
    });

    console.log("data>>>>", data)

    // Step 3: Store indicatorValues if it's not empty
    if (indicatorValues.length > 0) {
      ChangeData['indicator'] = indicatorValues.join(', ');
    }


    const existingTabs = searchParams.get('advancedSearchMiniTab');
    const advancedSearchTab = searchParams.get('advancedSearchTab');
    const removeNullKeys = removeEmptyFields(ChangeData)
    const updatedUrl = `/search?AdvancedSearch=${encodeURIComponent(JSON.stringify(removeNullKeys))}${existingTabs ? `&advancedSearchMiniTab=${existingTabs}` : ''}${advancedSearchTab ? `&advancedSearchTab=${advancedSearchTab}` : ''}`;

    navigate(updatedUrl);
  };

  console.log("searchedData>>>", searchedData)
  const removeEmptyFields = (obj) => {
    if (Array.isArray(obj)) {
      return obj
        .map(removeEmptyFields) // Recursively clean array items
        .filter((item) => item !== null && item !== undefined); // Remove null/undefined items
    } else if (obj && typeof obj === 'object') {
      return Object.entries(obj).reduce((acc, [key, value]) => {
        const cleanedValue = removeEmptyFields(value); // Recursively clean nested objects
        if (cleanedValue !== null && cleanedValue !== undefined && cleanedValue !== '') {
          acc[key] = cleanedValue;
        }
        return acc;
      }, {});
    }
    return obj; // Return primitive values as-is
  };
  const formatCurrency = (value) => {
    if (isNaN(value)) return '-'; // Handle invalid or null values
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0, // Ensure no decimal places
      maximumFractionDigits: 0, // No decimal places
    }).format(Math.trunc(value)); // Remove decimals without rounding
  };

  const reCallApi = (data) => {
    const cleanedData = removeEmptyFields(data);
    AdvSearchCall(cleanedData); // Call the API with the cleaned data
  };

  useEffect(() => {
    if (advancedSearchTab) {
      const tab = JSON.parse(decodeURIComponent(advancedSearchTab))
      setSelectedFields({ [tab]: true })
    }
  }, [advancedSearchTab])

  useEffect(() => {
    if (advancedSearchUrlQuery) {
      try {
        const parsedData = JSON.parse(decodeURIComponent(advancedSearchUrlQuery));
        reCallApi({ ...parsedData, page_no: currentPage });
        setAdvPostData(parsedData);
      } catch (error) {
      }
    }
  }, [advancedSearchUrlQuery]);

  const clearSearch = (resetForm, reset) => {
    setAdvPostData();
    resetForm();
    reset();
    resetForm({
      values: {
        platinum: false,
        gold: false,
        silver: false,
        bronze: false,
        'Bronze under review for higher certification': false,
        'basic level': false,
        'entry level': false,
      },
    });

    // Get current URL parameters
    const searchParams = new URLSearchParams(window.location.search);

    // Remove only the AdvancedSearch parameter (or any related filters)
    searchParams.delete('AdvancedSearch');

    // Use window.history.replaceState to update the URL **without page refresh**
    window.history.replaceState(null, '', `${window.location.pathname}?${searchParams.toString()}`);
  };
  useEffect(() => {
    if (!token) {
      const fetchIP = async () => {
        try {
          const ipAddress = await publicIpv4();
          setIp(ipAddress);
        } catch (error) {
          console.error("Error fetching IP:", error);
        }
      };
      fetchIP();
    }
  }, [token]);

  const { data: CountData, refetch } = useQuery({
    queryKey: ["count", ip],
    queryFn: () => getCount(ip),
    enabled: !!ip, // Ensures it runs only when IP is available
  });

  const { mutate: postUserViewCount } = useMutation({
    mutationFn: postUserCountApi,
    onMutate: async () => {
      await queryClient.cancelQueries(["count", ip]); // Cancel ongoing queries
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["count", ip]); // Refresh query
      refetch(); // Ensure fresh data
    },
  });

  const navigateToProfilePage = (id, url) => {
    let pathname = url;

    try {
      const urlObj = new URL(url);
      pathname = urlObj.pathname; // Extract only the relative path
    } catch (error) {
      // If it's already a relative path, ensure it starts with "/"
      pathname = url?.startsWith('/') ? url : `/${url}`;
    }
    if (!token && !dataUserAccessToken) {
      if (CountData?.count < 5 || !CountData?.count) {
        const Data = {
          args: {
            ip_address: ip,
            count: 1,
          },
        };
        postUserViewCount(Data);
        if (url) {
          navigate(pathname);
        } else {
          navigate(`/npo-profile/${id}`);
        }
      } else {
        enqueueSnackbar('Please log in to view more profiles.', { variant: 'warning' })
      }
    } else {
      if (url) {
        navigate(pathname);
      } else {
        navigate(`/npo-profile/${id}`);
      }
    }
  };

  return (
    <>
      <HeaderSec
        searchKey={searchKey}
        setTempSearch={setTempSearch}
        setSearchKey={setSearchKey}
        theme={"light"} />
      {/* <Header /> */}
      <div className=' w-[100%] flex gap-[20px]  '>
        <div className='flex justify-center flex-col items-center  mt-[10px] w-[100%]'>
          <ParagraphComp className=' text-2xl font-bold mt-[10px] text-[#004878]' text={`Look up NPOs/ NGOs to access the information you need to do good!`} />
          <div>
            <div className='flex mt-[20px] gap-[10px]'>
              <SearchBox
                clearButtonRef={clearButtonRef}
                searchKey={searchKey}
                TempSearch={TempSearch}
                setTempSearch={setTempSearch}
                setSearchKey={setSearchKey}
              />
              {/* <ButtonComp  className='rounded-xl  bg-[#d03737] px-[30px] border-2 border-[#004878] text-white' text='Register For Free' /> */}
            </div>
            <div className='flex justify-end mt-[10px] w-[100%]'>
              {!token &&
                <a className='text-xl cursor-pointer underline italic font-light text-[black]' href="/loginDataUser">Sign in/ Register for free for better search experience! </a>
              }
            </div>
          </div>
        </div>
        {/* <ButtonComp onClick={() => { openModal() }} className=' text-sm border-1 py-[7px] h-fit border-[black] rounded-full px-[20px] text-[#004878]' text='Advanced Search' /> */}
      </div>

      <div className='p-[10px] border-t-4 mt-[20px] border-[#004878] h-auto flex max-md:flex-col w-[100%]'>
        <div className='w-[25%] max-md:w-[100%] p-[10px] '>
          {/* <ButtonComp className={'rounded-t-lg  bg-[#004878] w-[100%] text-lg text-white '} text='' /> */}
          <ParagraphComp className='text-2xl tracking-wide text-[#004878] mb-[20px] font-bold text-start' >Advanced Search Filters </ParagraphComp>
          <div className='w-[100%] min-h-[46vh] h-[100%] bg-[#EDF2F6]'>
            <div className='p-[10px] '>
              <div className='flex w-[100%] justify-between flex-wrap gap-[10px]'>
                {buttons.map(ele =>
                  <>
                    <div className={`${ele === 'Trust and Transparency Level' ? 'w-full' : 'w-[48%]'}`}>
                      <ButtonComp
                        onClick={() => { updateBtnName(ele) }}
                        className={
                          selectedFields?.[ele]
                            ? 'bg-[#004878] transition-[2s] h-[40px] rounded-xl text-md w-full text-white overflow-hidden text-ellipsis whitespace-nowrap'
                            : 'border-2 p-[5px] h-[40px] border-[#004878] w-full bg-white rounded-xl text-md text-[#004878] overflow-hidden text-ellipsis whitespace-nowrap'
                        }
                        text={ele}
                      />
                    </div >
                  </>
                )}
              </div>
              <div className={` ${searchedData.length >= 3 ? 'h-[100%] max-h-[100%] ' : 'h-[57vh] overflow-x-hidden overflow-scroll'} `}>
                <Formik
                  innerRef={formRef}
                  initialValues={initialValues}
                  validationSchema={modelSchema}
                  onSubmit={(data) => {
                    submitData(data);
                  }}
                >
                  {({ values, handleChange, setFieldValue, resetForm, errors }) => (
                    <Form className="w-[100%]">
                      {selectedFields?.['Geography'] ?
                        <>
                          <GeographyAdv
                            values={values}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            tabs={tabs}
                            setTabs={setTabs}
                            reset={reset}
                            AdvPostData={AdvPostData}
                            setAdvPostData={setAdvPostData}
                            reCallApi={reCallApi}
                            districtsDatas={districtsDatas}
                            stateDatas={stateDatas}
                          />
                        </>
                        :
                        selectedFields?.['Cause'] ?
                          <>
                            <Cause
                              values={values}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              reset={reset}
                              tabs={tabs}
                              setTabs={setTabs}
                              populationsDatas={populationsDatas}
                              AdvPostData={AdvPostData}
                              CauseDatas={CauseDatas}
                              setAdvPostData={setAdvPostData}
                              reCallApi={reCallApi}
                            />
                          </>
                          :
                          selectedFields?.['Get Involved'] ?
                            <>
                              <MakeADifference
                                values={values}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                reset={reset}
                                tabs={tabs}
                                setTabs={setTabs}
                                setAdvPostData={setAdvPostData}
                                AdvPostData={AdvPostData}
                                reCallApi={reCallApi}
                              />
                            </>
                            :
                            selectedFields?.['Financial'] ?
                              <>
                                <Finance
                                  values={values}
                                  handleChange={handleChange}
                                  setFieldValue={setFieldValue}
                                  resetForm={resetForm}
                                  reset={reset}
                                  tabs={tabs}
                                  setTabs={setTabs}
                                  setAdvPostData={setAdvPostData}
                                  AdvPostData={AdvPostData}
                                  reCallApi={reCallApi}
                                />
                              </>
                              :
                              selectedFields?.['Trust and Transparency Level'] ?
                                <>
                                  <TrustAndTransparencyAdv
                                    values={values}
                                    handleChange={handleChange}
                                    setFieldValue={setFieldValue}
                                    reset={reset}
                                    setAdvPostData={setAdvPostData}
                                    AdvPostData={AdvPostData}
                                    reCallApi={reCallApi}
                                  />
                                </>
                                :
                                ''

                      }
                      <div className='mt-[30px] w-[100%] flex gap-[10px] justify-end'>
                        <button ref={clearButtonRef} onClick={() => { clearSearch(resetForm, reset) }} type='button' className=' rounded-full text-xl py-[5px] px-[20px] text-[#004878] border-2 border-[#004878] bg-transparent ' >Clear search</button>
                        <ButtonComp type='submit' text='Search' className='border-none rounded-full text-xl py-[5px] px-[20px] text-white bg-[#004878] ' />
                      </div>
                      {/* < DisplayFormikValues /> */}
                    </Form>
                  )
                  }
                </Formik >
              </div>

            </div>
          </div>
        </div>
        <div className='w-[70%] max-md:w-[100%] flex flex-col gap-[50px]'>
          <div className='flex flex-col gap-[20px]'>
            <div className='flex max-md:flex-col justify-between'>
              <div>
                <div className='h-[100px]  max-md:h-[auto] flex items-center  '>
                  {searchedData?.length > 0 ?
                    <div className='flex flex-col mt-[10px] gap-[5px]'>
                      {searchedData?.length > 0 ?
                        <ParagraphComp className='text-xl text-[#004878] font-semibold text-start ' text={`${getData?.total_count || searchResults?.total_count} Result(s) found`} />
                        : ''
                      }
                      <div className='flex'>
                        <ParagraphComp className='text-xl text-[#004878] mb-[0px] font-semibold text-start ' text={`You can view up to 5 organisations`} />
                      </div>
                      {!token &&
                        <a href='/loginDatauser' className='text-xl cursor-pointer text-[#004878] text-start underline' >Sign in/ Register for free for better search experience!</a>
                      }
                      {searchedData &&
                        <a onClick={handleClearSearch} className='text-xl cursor-pointer text-[#004878]  text-start underline' >Clear Search</a>
                      }
                    </div>
                    : ''}
                </div>
              </div>
              < div className='w-[250px] max-md:w-[100%] max-md:mt-[20px] p-[10px]'>
                <CustomSelection value={selectedFilter} onChange={(e) => { setSelectedFilter(e?.target?.value) }} disabledFilter={true} mappingKey='option' options={[
                  { option: 'Trust & Transparency Level (High to Low)' },
                  { option: 'Organisation Name (A-Z)' },
                  // { option: 'Completeness of Profile (High to Low)' },
                ]} label={'Sort By'} />
              </div>
            </div>
          </div>
          <>
            {fieldLoading || advLoading ?
              <div className='h-[50vh] flex justify-center items-center w-[100%]'>
                < div className="spinner"></div>
              </div>
              :
              <>
                {(searchKey || AdvPostData) && (searchedData?.length === 0) ?
                  <ErrorMessage searchKey={searchKey ||
                    Object.keys(AdvPostData)
                      .map(key =>
                        key.replace(/_/g, ' ') // Replace underscores with spaces
                          .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize first letter of each word
                      )
                      .join(', ')}
                  /> :
                  (searchedData?.length === 0 ? !searchKey || !AdvPostData : '')
                  && <InitialMessage />}
                {(searchedData?.length > 0) &&
                  searchedData?.map((item, index) =>
                    <div key={index}>
                      <div className='border-2  rounded-[20px] p-[20px] shadow-xl '>
                        <div className=' flex max-md:flex-col justify-between '>
                          <div className='w-[60%] max-md:w-[100%]'>
                            <div>
                              <HeaderCompo tagType='h5' className='text-xl font-bold mb-[10px]   text-[#004878]' text={`GuideStar Number (GSN): ${item?.['gsn_number']}`} />
                              <div onClick={() => {
                                navigateToProfilePage(item?.['npo_profile'], item?.customize_url)
                              }}>
                                <HeaderCompo tagType='h5' className='text-2xl font-bold mb-[10px] underline cursor-pointer text-[#004878]' text={item?.['organisation_name']} />
                              </div>
                            </div>
                            <ParagraphComp className='text-[#000000cf] mt-[10px] font-sans font-[500] leading-[25px] text-xl' >
                              Also known As / Abbreviation: <span className='font-bold text-[#004878]'>{item?.['short_name']}</span>
                            </ParagraphComp>
                            <ParagraphComp className='text-[black] font-[500] font-sans leading-[25px] mt-[10px]  text-xl' >
                              PAN:  <span className='font-bold text-[#004878]'>{item?.['pan_number']}</span>
                            </ParagraphComp>
                            <div className='flex gap-1 items-center mt-[20px] '>
                              <PlaceIcon id="searchIconSize" className=' text-black' />
                              <ParagraphComp className='text-[black] leading-[25px] text-xl' >
                                {item?.place}{!item?.place && '-'}, {item?.state} {!item?.state && '-'}
                              </ParagraphComp>
                            </div>
                            <ParagraphComp className='text-[#004878] italic w-[98%] mt-[20px] leading-[25px] text-xl' >
                              {getSummaryDescription(item)}
                            </ParagraphComp>
                          </div>
                          <div className='w-[40%] max-md:w-[100%]'>
                            <div className='flex flex-col items-center justify-center'>
                              <div className='min-h-[160px] flex justify-center'>
                                {item?.['certification_level'] === 'Platinum' ?
                                  <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/platinum.jpg' />
                                  :
                                  item?.['certification_level'] === 'Gold' ?
                                    <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/gold.jpg' />
                                    :
                                    item?.['certification_level'] === 'Bronze' ?
                                      <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/bronze.jpg' />
                                      :
                                      item?.['certification_level'] === 'Discover' ?
                                        <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/discover.jpg' />
                                        :
                                        item?.['certification_level'] === 'Silver' ?
                                          <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/silver.jpg' />
                                          :
                                          item?.['certification_level'] === 'Bronze under review for higher certification' ?
                                            <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/Seal design_page-0005.jpg' />
                                            :
                                            item?.['certification_level'] === 'Entry Level' ?
                                              <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/Seal design_page-0007.jpg' />
                                              :
                                              item?.['certification_level'] === 'Basic Level' ?
                                                <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/Seal design_page-0006.jpg' />
                                                :
                                                item?.['certification_level'] === 'Engage' ?
                                                  <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/engage.jpg' />
                                                :
                                                item?.['certification_level'] === 'Claim your profile' ?
                                                  <ImageComp className='h-[220px] max-md:h-[180px]' source='./Images/Claim your profile.jpg' />
                                                  : ''
                                }
                              </div>
                              <div className='w-[100%] mt-[10px] rounded-lg p-[10px] bg-[#EDF2F6] '>
                                {item['valid_till'] ?
                                  <ParagraphComp className="text-[#004878] text-md font-[700] font-sans">
                                    Transparency seal valid till:&nbsp;
                                    <span className="font-[400]">
                                      {item?.['valid_till']
                                        ? new Date(item['valid_till']).toLocaleDateString('en-GB').replace(/\//g, '-')
                                        : '-'}
                                    </span>
                                  </ParagraphComp>
                                  : ""
                                }
                                <ParagraphComp className='text-[#004878] text-md font-[700] font-sans'  >
                                  Tax Exemption: <span className='font-[400]'>{item?.['tax_exempt_under'] || item?.['tax_exempt under'] || '-'}, <span className='font-bold'>Valid till: </span> {item?.['tax_exempt_valid_till'] || item?.['tax_exempt_valid_till'] || '-'}</span>
                                </ParagraphComp>
                                <ParagraphComp className='text-[#004878] text-md font-[700] font-sans '  >
                                  Tax Deduction: <span className='font-[400]'> {item?.['tax_deduction_under'] || item?.['tax_deduction under'] || '-'}, <span className='font-bold'>Valid till: </span> {item?.['tax_deduction_valid_till'] || item?.['tax_deduction_valid_till'] || '-'}</span>
                                </ParagraphComp>
                                <ParagraphComp className='text-[#004878] text-md font-[700] font-sans '  >
                                  FCRA Status: <span className='font-[400]'> {item?.['fcra_status'] || '-'}</span>
                                </ParagraphComp>
                                <ParagraphComp className='text-[#004878] text-md font-[700] font-sans '  >
                                  FCRA Valid till:<span className='font-[400]'> {item?.['fcra_registration_valid_till'] || '-'}</span>
                                </ParagraphComp>
                                <ParagraphComp className='text-[#004878] text-sm text-start italic font-sans  '  >
                                  Please check the respective government site for eligibility and validity as on date
                                </ParagraphComp>
                              </div>
                              <div className='flex w-[100%] mt-[10px] justify-between'>
                                <div className='w-[49%] p-[10px] flex bg-[#EDF2F6] rounded-lg flex-col items-center'>
                                  <ParagraphComp className='text-[#004878] text-md font-[700] font-sans'  >
                                    Expenditure {!item?.['annual_expenditure'] && '-'}
                                  </ParagraphComp>
                                  <ParagraphComp className='text-[#004878] text-md font-[500] font-sans'>
                                    {item?.annual_expenditure_year ? `FY ${item.annual_expenditure_year}: ` : ''}
                                    {item?.annual_expenditure ? formatCurrency(item?.annual_expenditure) : ''}
                                  </ParagraphComp>
                                </div>
                                <div className='w-[49%] p-[10px] flex-col rounded-lg bg-[#EDF2F6] flex items-center j'>
                                  <ParagraphComp className='text-[#004878] text-md font-[700] font-sans '  >
                                    Assets {!item?.['annual_assets'] && '-'}
                                  </ParagraphComp>
                                  <ParagraphComp className='text-[#004878] text-md font-[500] font-sans'>
                                    {item?.annual_assets_year ? `FY ${item.annual_assets_year}: ` : ''}
                                    {item?.annual_assets ? formatCurrency(item?.annual_assets) : ''}
                                  </ParagraphComp>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  )
                }
              </>
            }
            <div className='flex justify-center'>
              {searchedData?.length > 0 &&
                <Stack spacing={2} className="mt-4">
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                    size="large"
                    showFirstButton
                    showLastButton
                    variant="outlined"
                    shape="rounded"
                  />
                </Stack>
              }

            </div>

            {(!token && !dataUserAccessToken) && (searchedData?.length <= 5 && searchedData?.length > 0) &&
              <div className='flex  justify-center'>
                <div className='bg-[#004878] items-center p-[10px] w-fit rounded-xl flex gap-[20px]'>
                  <ParagraphComp className={'text-md max-md:text-sm text-[#ffffffbd]'} text='You can view 5 NPO profiles. Please register or log in to continue viewing more NPO profiles.' />
                  <ButtonComp onClick={() => { navigate('/loginDataUser') }} className='px-[20px] max-md:text-sm bg-white rounded-full py-[5px] text-[#004878]' text='Register/Log In' />
                </div>
              </div>
            }
          </>
          {/* } */}
        </div >
      </div >
      <FooterComp />

    </>
  )
}

export default NpoSearch